<div class="serial-stock">
  <p class="serial-stock-note">{{ 'serials.readOnly' | translate }}</p>

  <div class="serial-state" *ngIf="loading" aria-busy="true">
    <mat-spinner diameter="28"></mat-spinner>
  </div>

  <div class="serial-state" *ngIf="!loading && error">
    <strong>{{ 'serials.loadError' | translate }}</strong>
    <button type="button" mat-stroked-button (click)="load()">{{ 'serials.tryAgain' | translate }}</button>
  </div>

  <div class="serial-state" *ngIf="!loading && !error && total === 0">
    <strong>{{ 'serials.emptyTitle' | translate }}</strong>
    <span>{{ 'serials.emptyText' | translate }}</span>
  </div>

  <ng-container *ngIf="!loading && !error && total > 0">
    <div class="serial-stock-bar">
      <span class="serial-stock-summary">
        {{ (term ? 'serials.summaryFiltered' : 'serials.summary') | translate: { count: term ? matchTotal : total, total: total, storages: visibleGroups.length } }}
      </span>
      <input *ngIf="total >= filterFrom" class="serial-stock-filter" type="search" [(ngModel)]="filter"
             [attr.aria-label]="'serials.filter' | translate" [placeholder]="'serials.filter' | translate" />
      <button type="button" class="serial-link" *ngIf="groups.length > 1 && !term" (click)="expandAll(!allOpen)">
        {{ (allOpen ? 'serials.collapseAll' : 'serials.expandAll') | translate }}
      </button>
    </div>

    <div class="serial-state" *ngIf="term && matchTotal === 0">
      <strong>{{ 'serials.noMatchTitle' | translate: { term: filter.trim() } }}</strong>
      <span>{{ 'serials.noMatchText' | translate }}</span>
      <button type="button" mat-stroked-button (click)="filter = ''">{{ 'serials.clearFilter' | translate }}</button>
    </div>

    <div class="serial-group" *ngFor="let x of visibleGroups">
      <button type="button" class="serial-group-head" [attr.aria-expanded]="isOpen(x.group)" (click)="toggle(x.group)">
        <mat-icon class="serial-chevron">chevron_right</mat-icon>
        <span class="serial-group-text">
          <span class="serial-group-name">{{ x.group.name || ('serials.noStorage' | translate) }}</span>
          <span class="serial-group-path" *ngIf="x.group.path">{{ x.group.path }}</span>
        </span>
        <span class="serial-group-count">
          {{ term ? (('serials.ofCount' | translate: { count: x.rows.length, total: x.group.rows.length })) : x.rows.length }}
          <small>{{ 'serials.serials' | translate }}</small>
        </span>
      </button>
      <ul class="serial-rows" *ngIf="isOpen(x.group)">
        <li class="serial-row" *ngFor="let r of x.rows | slice:0:limit(x.group)">
          <span class="serial-no"><ng-container *ngIf="highlight(r.serialNumber) as h">{{ h.pre }}<mark *ngIf="h.hit">{{ h.hit }}</mark>{{ h.post }}</ng-container></span>
          <span class="serial-meta" *ngIf="r.receivedAt">{{ 'serials.received' | translate: { date: (r.receivedAt | date:'MMM d, y') } }}</span>
        </li>
      </ul>
      <button type="button" class="serial-more" *ngIf="isOpen(x.group) && x.rows.length > limit(x.group)" (click)="more(x.group)">
        {{ 'serials.showMore' | translate: { n: step, left: x.rows.length - limit(x.group) } }}
      </button>
    </div>

    <p class="serial-stock-foot"><a href="#" class="serial-link" (click)="openReport($event)">{{ 'serials.openReport' | translate }}</a></p>
  </ng-container>
</div>
